var _style, _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEtc = function SvgEtc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "etc_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".etc_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "etc_svg__st0",
    d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "etc_svg__st1",
    cx: 5.6,
    cy: 12,
    r: 1.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "etc_svg__st1",
    cx: 12,
    cy: 12,
    r: 1.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "etc_svg__st1",
    cx: 18.4,
    cy: 12,
    r: 1.6
  })));
};
export default SvgEtc;